import React from 'react';
import { Link } from 'react-router-dom';
import { blogCategories, getSortedBlogPosts } from '../data/blogPosts';
import { formatPublishedDate } from '../utils/blogDates';
import BlogCardThumb from './blog/BlogCardThumb';

export default function BlogSection() {
  return (
    <section className="section blog-showcase" id="blog" aria-labelledby="blog-showcase-heading">
      <div className="blog-showcase__wash" aria-hidden />
      <div className="blog-showcase__shell">
        <header className="blog-showcase__masthead">
          <div className="blog-showcase__masthead-main">
            <p className="blog-showcase__eyebrow">Free guides</p>
            <h2 id="blog-showcase-heading" className="blog-showcase__headline">
              <span className="blog-showcase__headline-label">Guides:</span>{' '}
              <span className="blog-showcase__headline-accent">weight loss, Indian meals, and habits</span>
            </h2>
          </div>
          <p className="blog-showcase__dek">
            Long-form resources for a <strong>no tracking diet</strong>, <strong>simple diet plan India</strong> readers
            search for, and sustainable routines—each links back to Notrack early access.
          </p>
        </header>

        <div className="blog-showcase__topics" aria-label="Blog categories">
          {blogCategories.map((c) => (
            <span key={c} className="blog-cat-pill blog-showcase__topic">
              {c}
            </span>
          ))}
        </div>

        <div className="blog-grid blog-grid--home blog-grid--showcase">
          {getSortedBlogPosts().map((p) => (
            <article key={p.slug} className="card blog-card blog-card--grid">
              <Link to={`/blog/${p.slug}`} className="blog-card-media-link" tabIndex={-1} aria-hidden="true">
                {(p.heroImage || p.listImage) && (
                  <BlogCardThumb
                    src={(p.listImage || p.heroImage).src}
                    alt={(p.listImage || p.heroImage).alt}
                  />
                )}
              </Link>
              <div className="blog-card-body">
                <div className="blog-card-meta">
                  <span className="blog-card-cat">{p.category}</span>
                  <time className="blog-card-date" dateTime={p.published}>
                    {formatPublishedDate(p.published)}
                  </time>
                  <span className="blog-card-read" aria-hidden>
                    · {p.readTime}
                  </span>
                </div>
                <h3 className="blog-card-title">
                  <Link to={`/blog/${p.slug}`}>{p.title}</Link>
                </h3>
                <p className="body dim">{p.metaDescription}</p>
                <Link className="blog-card-link" to={`/blog/${p.slug}`}>
                  Read guide →
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="blog-showcase__cta">
          <Link className="btn btn-secondary blog-showcase__cta-btn" to="/blog">
            View all articles
          </Link>
        </div>
      </div>
    </section>
  );
}
